import { User } from '~/lib/models/user/user'
import { UserAddress } from '~/lib/models/user/user-address'
import { USER_ROLES } from '~/lib/constants/user-roles'

/**
 * @param {Object} user
 * @returns {momentshare.models.user.User}
 */
export function mapUser(user) {
  const role = user.role
  const isAdmin = role === USER_ROLES.ADMIN
  const isSubscriber = isAdmin || role === USER_ROLES.SUBSCRIBER

  return new User({
    id: user.id,
    username: user.username,
    displayName: user.displayName,
    googleDriveConnected: user.googleDriveConnected,
    dropboxConnected: user.dropboxConnected,
    address: user.address ? mapUserAddress(user.address) : null,
    role,
    isAdmin,
    isSubscriber,
  })
}

/**
 * @param {Object} address
 * @returns {momentshare.models.user.UserAddress}
 */
export function mapUserAddress(address) {
  return new UserAddress({
    id: address.id,
    name: address.name,
    postalCode: address.postalCode,
    address: address.address,
    city: address.city,
    country: address.country,
    vatNumber: address.vatNumber,
  })
}
